import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { GameProvider } from "@/contexts/GameContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { CoopProvider } from "@/contexts/CoopContext";
import { ProfileProvider } from "@/contexts/ProfileContext";
import { SocialProvider } from "@/contexts/SocialContext";
import { MissionsProvider } from "@/contexts/MissionsContext";
import MainMenu from "@/pages/MainMenu";
import ClassSelect from "@/pages/ClassSelect";
import MapView from "@/pages/MapView";
import IsometricMap from "@/pages/IsometricMap";
import CoopMap from "@/pages/CoopMap";
import Combat from "@/pages/Combat";
import ChestRoom from "@/pages/ChestRoom";
import Sanctuary from "@/pages/Sanctuary";
import Shop from "@/pages/Shop";
import GameOver from "@/pages/GameOver";
import AuthCallback from "@/pages/AuthCallback";
import Settings from "@/pages/Settings";
import Friends from "@/pages/Friends";
import Lobby from "@/pages/Lobby";
import Profile from "@/pages/Profile";
import MenuShop from "@/pages/MenuShop";
import PvP from "@/pages/PvP";
import PvPDuel from "@/pages/PvPDuel";
import PvPDungeon from "@/pages/PvPDungeon";
import Missions from "@/pages/Missions";
import { CoopChatWidget } from "@/components/game/CoopChatWidget";
import { DailyRewardModal } from "@/components/game/DailyRewardModal";
import { ProfileModal } from "@/components/social/ProfileModal";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<MainMenu />} />
        <Route path="/select" element={<ClassSelect />} />
        <Route path="/map" element={<IsometricMap />} />
        <Route path="/coop-map" element={<CoopMap />} />
        <Route path="/combat" element={<Combat />} />
        <Route path="/chest" element={<ChestRoom />} />
        <Route path="/sanctuary" element={<Sanctuary />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/gameover" element={<GameOver />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/friends" element={<Friends />} />
        <Route path="/lobby" element={<Lobby />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/shop-menu" element={<MenuShop />} />
        <Route path="/pvp" element={<PvP />} />
        <Route path="/pvp-duel/:matchId" element={<PvPDuel />} />
        <Route path="/pvp-dungeon/:matchId" element={<PvPDungeon />} />
        <Route path="/missions" element={<Missions />} />
      </Routes>
      {location.pathname !== "/lobby" && <CoopChatWidget />}
      <DailyRewardModal />
      <ProfileModal />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ProfileProvider>
          <MissionsProvider>
            <SocialProvider>
              <CoopProvider>
                <GameProvider>
                  <BrowserRouter>
                    <Toaster position="top-right" theme="dark" richColors />
                    <AppRouter />
                  </BrowserRouter>
                </GameProvider>
              </CoopProvider>
            </SocialProvider>
          </MissionsProvider>
        </ProfileProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
